<template>
  <div class="file-uploader file__attach text-center" @click="$refs.document.click()">
    <v-icon class="file-uploader__icon mb-1" large>mdi-cloud-upload-outline</v-icon>
    <div class="file-uploader__text">
      <slot/>
    </div>
    <input
      type="file"
      class="d-none"
      ref="document"
      accept="image/*, application/pdf"
      @change="OnFilePicked">
  </div>
</template>

<script>
export default {
  name: 'FileUploaderComponent',
  data() {
    return {
      document: { filename: '', base64: '', name: '', url: '', id: null },
    };
  },
  methods: {
    /**
     * Добавление документа к продаже.
     * @param e эвент
     */
    OnFilePicked(e) {
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        const [file] = files;
        if (file.name.lastIndexOf('.') <= 0) return;
        app.document.name = file.name;
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          app.document.file = null;
          app.document.base64 = fr.result;
          app.$forceUpdate();
        });
        app.$emit('click', app.document);
      } else {
        app.document = { filename: '', base64: '', name: '', url: '', id: null };
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.file-uploader {
  &__icon {
    &.v-icon.v-icon {
      color: $sale-file-btn-color;
      transition: color .3s ease;
    }
  }

  span {
    display: block;
    color: $sale-file-btn-color;
    font-size: 11px;
    line-height: 1.2;
    transition: color .3s ease;
  }
  &:hover {
    cursor: pointer;

    span {
      color:$sale-file-btn-hover-color;
      transition: color .3s ease;
    }
    .v-icon.v-icon {
      color: $sale-file-btn-hover-color;
      transition: color .3s ease;
    }
  }
}
</style>
